function isMobile() {
  return (navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    navigator.userAgent.match(/ZuneWP7/i)
  );
}

// rounds number to nearest integer and returns it displayed
// in local number format
function format_number(number) {
  number = parseInt(number);
  return number.toLocaleString();
}

function unix_to_datestring(unix) {
  return (new Date(unix * 1000)).toLocaleDateString();
}

function addCommasTooltip(tooltipItem, data) {
  let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  if(parseInt(value) >= 1000){
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return '$' + value;
  }
}

function addCommasTicks(value, index, values) {
  if(parseInt(value) >= 1000){
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return '$' + value;
  }
}
module.exports = { isMobile, format_number, unix_to_datestring, addCommasTooltip, addCommasTicks }
